import { useEffect, useMemo, useState } from "react"
import { Link, useHistory } from 'react-router-dom'
import { Button, Table, Space, DatePicker } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'
import _ from 'lodash'
import moment from "moment"

const { Column } = Table

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type fetchParams = {
    store_id: string | undefined
    order_date: any
    dining_date: any
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        store_id: undefined,
        order_date: null,
        dining_date: null
    }

    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [data, setData] = useState<any>([])

    const history = useHistory()

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        if (params.order_date) {
            params.order_date = moment(params.order_date).format('YYYY-MM-DD')
        }

        if (params.dining_date) {
            params.dining_date = moment(params.dining_date).format('YYYY-MM-DD')
        }

        axiosTable.get('/cooking_center/kitchen/dining_order/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    return (<div className="common-page">
        {/* 膳食中心 -> 厨房管理 -> 客餐订单管理 */}
        <BreadCrumb position={['膳食中心', '客餐订单管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores onChange={(value: string) => { handleChange(value, 'store_id') }} value={fetchOtherParams.store_id} />
                </div>

                <DatePicker className="fl" style={{ marginRight: 8, marginBottom: 12 }} placeholder={'下单日期'} value={fetchOtherParams.order_date} onChange={(v: any) => { handleChange(v, 'order_date') }} />
                <DatePicker className="fl" style={{ marginRight: 8, marginBottom: 12 }} placeholder={'用餐日期'} value={fetchOtherParams.dining_date} onChange={(v: any) => { handleChange(v, 'dining_date') }} />
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="order_id" pagination={pagination} onChange={handleTableChange}>
                <Column title="下单日期" dataIndex="order_date" key="order_date" />
                <Column title="用餐日期" dataIndex="dining_date" key="dining_date" />
                <Column title="客餐门店" dataIndex="store_name" key="store_name" />
                <Column title="客餐订单号" dataIndex="menu_order_code" key="menu_order_code" />
                <Column title="食材订单号" dataIndex="food_order_code" key="food_order_code" />
                <Column title="食材订单状态" dataIndex="food_order_status" key="food_order_status"
                    render={(text, record: any) => {
                        const { food_order_status } = record

                        if (food_order_status == 1) {
                            return '已下单'

                        } else {
                            return '未下单'
                        }
                    }}
                />
                <Column title="下单人" dataIndex="create_user_name" key="create_user_name" />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        const { order_id, store_name, store_id, dining_date, food_order_status } = record
                        return (<Space size="middle">

                            {permission.includes('查看详情') && <Button size="small" onClick={() => {
                                history.replace({
                                    pathname: '/dining_order_detail',
                                    state: { order_id, store_name, store_id, dining_date }
                                })
                            }} >查看详情</Button>}
                            {
                                food_order_status == 0 && <Link to={{ pathname: '/food_dail_edit', state: { order_id, store_name } }}>食材采购</Link>
                            }
                        </Space>)
                    }}
                />
            </Table>
        </div>
    </div>)
}